import ArticleCard from 'components/ArticleCard';
import ColumnsLayout from 'components/contentLayouts/ColumnsLayout';
import MaxWidthWrapper from 'components/wrappers/MaxWidthWrapper';
import PropTypes from 'prop-types';
import React from 'react';
import { mediaQueries } from 'config/theme/breakpoints';

const DesignerGridLayout = ({ designers = [] }) =>
    designers.length > 0 ? (
        <MaxWidthWrapper includeContentMargins>
            <ColumnsLayout
                blocks={designers.map(designer => (
                    <ArticleCard
                        heading={designer.heading}
                        image={designer.background}
                        key={designer.id}
                        mediaQuery={mediaQueries.threeColumn}
                        ratio={3 / 4}
                        to={designer.to}
                    />
                ))}
                columnSizes={[6, null, 4]}
                gutterWidth={[12, null, null, 24]}
                gutterHeight={[32, null, null, null, 54]}
            />
        </MaxWidthWrapper>
    ) : null;

DesignerGridLayout.propTypes = {
    designers: PropTypes.array,
};

export default DesignerGridLayout;
